<template>
  <div class="recommend">
    <div class="title">
      <img src="../assets/image/tips4_title.jpg" />
    </div>
    <div class="con">
      <div class="auto clearfix" @mouseleave="swplay" @mouseenter="swout">
        <swiper :options="swiperrecom" ref="swiperrecom" class="swiperrecom">
          <div class="swiper-slide" v-for="(data,index) in xjList" :key="index">
            <a style="margin:0" :href="data.href" target="_blank">
              <div class="topImg">
                <img :src="data.imgurl1" />
                <div
                  class="fontName"
                  style="position:absolute;left:10px;bottom:10px;color:#fff"
                >{{data.fontName}}</div>
              </div>
              <div class="bot">
                <div class="xj">
                  <img :src="data.imgurl2" />
                </div>
                <div class="title">{{data.title}}</div>
                <div class="font">{{data.font}}</div>
                <a :href="data.href" target="_blank">查看详情></a>
              </div>
            </a>
          </div>
        </swiper>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      xjList: [
        {
          fontName: "长尾林鸮",
          imgurl1: require("../assets/image/tips4_img1.jpg"),
          imgurl2: require("../assets/image/tips4_xj1.jpg"),
          title: "EOS R",
          font: "全画幅专微，影像无线分享",
          href: "http://www.canon.com.cn/product/r/"
        },
        {
          fontName: "叉尾太阳鸟",
          imgurl1: require("../assets/image/tips4_img2.jpg"),
          imgurl2: require("../assets/image/tips4_xj2.jpg"),
          title: "EOS-1D X Mark II ",
          font: "全画幅，专业机型，高速连拍",
          href: "http://www.canon.com.cn/product/1dxmk2/"
        },
        {
          fontName: "白鹭",
          imgurl1: require("../assets/image/tips4_img3.jpg"),
          imgurl2: require("../assets/image/tips4_xj3.jpg"),
          title: "EOS 90D",
          font: "更快、更高，不一样的摄影体验",
          href: "http://www.canon.com.cn/product/90d/"
        },
        {
          fontName: "白腰文鸟",
          imgurl1: require("../assets/image/tips4_img4.jpg"),
          imgurl2: require("../assets/image/tips4_xj4.jpg"),
          title: "EF 600mm f/4L IS III USM",
          font: "EF定焦镜头",
          href: "https://shop.canon.com.cn/prodetails?product_id=1614"
        },
        {
          fontName: "大鸨",
          imgurl1: require("../assets/image/tips4_img5.jpg"),
          imgurl2: require("../assets/image/tips4_xj5.jpg"),
          title: "EF 800mm f/5.6L IS USM",
          font: "EF定焦镜头",
          href: "https://shop.canon.com.cn/prodetails?product_id=1348"
        }
      ],
      swiperrecom: {
        loop: true,
        slidesPerView: 4,
        speed: 2000, //匀速时间
        spaceBetween: 20,
        autoplay: {
          delay: 0,
          stopOnLastSlide: false,
          disableOnInteraction: false
        }
      }
    };
  },
  methods: {
    swout() {
      this.$refs.swiperrecom.swiper.autoplay.stop();
    },
    swplay() {
      this.$refs.swiperrecom.swiper.autoplay.start();
    }
  }
};
</script>
<style scoped>
.recommend {
  float: left;
  width: 100%;
  background: #eeeeee;
}
.title {
  float: left;
  width: 100%;
  text-align: center;
}
.title img {
  width: 1200px;
}
.con {
  float: left;
  width: 100%;
  height: 680px;
  /* max-width: 1550px; */
  /* padding-bottom: 69px; */
}
.auto {
  width: 1200px;
  max-width: 1550px;
  min-width: 1200px;
  margin: 0 auto;
}
.swiperrecom {
  float: left;
  width: 100%;
  margin: 0 auto;
}
.swiperrecom .swiper-slide {
  float: left;
  width: 293px;
  height: 586px;
  background: #fff;
  padding-bottom: 10px;
  /* margin-right: 21px; */
}
/* ul li:last-child {
  margin: 0;
} */
.swiperrecom .swiper-slide .topImg {
  position: relative;
  float: left;
  width: 100%;
  height: 326px;
  overflow: hidden;
}
.swiperrecom .swiper-slide .topImg::after {
  position: absolute;
  bottom: -10px;
  left: 50%;
  transform: translateX(-50%) rotate(45deg);
  content: "";
  width: 15px;
  height: 15px;
  background: #fff;
}

.swiperrecom .swiper-slide .topImg:hover img {
  transform: scale(1.05);
  -webkit-transform: scale(1.05);
  -moz-transform: scale(1.05);
  -ms-transform: scale(1.05);
  -o-transform: scale(1.05);
}
.swiperrecom .swiper-slide .topImg img {
  float: left;
  width: 100%;
  height: 100%;
  transition: all 0.3s;
  -webkit-transition: all 0.3s;
  -moz-transition: all 0.3s;
  -ms-transition: all 0.3s;
  -o-transition: all 0.3s;
}
.swiperrecom .swiper-slide .bot {
  float: left;
  width: 100%;
}
.swiperrecom .swiper-slide .bot .xj {
  position: relative;
  width: 100%;
  float: left;
  height: 150px;
}
.swiperrecom .swiper-slide .xj img {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  -webkit-transform: translate(-50%, -50%);
  -moz-transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  -o-transform: translate(-50%, -50%);
}
.swiperrecom .swiper-slide .title,
.swiperrecom .swiper-slide .font {
  float: left;
  width: 100%;
  text-align: center;
}
.swiperrecom .swiper-slide .title {
  margin-bottom: 5px;
  font-size: 22px;
  color: #000;
}
.swiperrecom .swiper-slide .font {
  font-size: 18px;
  color: #333;
}
.swiperrecom .swiper-slide a {
  float: left;
  display: block;
  width: 100%;
  text-align: center;
  text-decoration: none;
  color: #f08200;
  margin-top: 15px;
}

/* @media screen and (max-width: 1565px) {
  .auto {
    width: 1200px;
  }
  ul li {
    margin-right: 160px;
  }
  ul li:nth-child(3) {
    margin-right: 0;
  }
  ul li:nth-child(4) {
    margin-left: 230px;
  }
  ul li:nth-child(n + 4) {
    margin-top: 20px;
  }
} */
</style>